import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";
import PostCard from "@/components/base/PostCard";

export default function HotPick() {
  const ranked = [...posts].sort((a, b) => b.likes - a.likes);
  const feature = ranked[0];
  const sideList = ranked.slice(1, 6);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
      <article className="lg:col-span-7">
        <Link
          to={`/post/${feature.id}`}
          className="group block h-full rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
            <img
              src={feature.cover}
              alt={`${feature.title} - 网爆吃瓜热门推荐`}
              title={`${feature.title} - 网爆吃瓜`}
              className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
            />
            <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-accent-950 text-xs whitespace-nowrap">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-trophy-line"></i>
              </span>
              本周最高赞
            </span>
          </div>
          <div className="p-5 md:p-6">
            <h3 className="text-lg md:text-2xl text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
              {feature.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">{feature.excerpt}</p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {feature.tags.map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </Link>
      </article>

      <div className="lg:col-span-5">
        <ul className="flex flex-col gap-3">
          {sideList.map((post) => (
            <li key={post.id}>
              <PostCard post={post} variant="row" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}